
import React from "react";
import { Campaign } from "@/types/campaigns";
import { getCampaignTypeDisplayName } from "@/utils/campaignTypeTranslations";

interface CampaignTemplateInfoProps {
  campaign: Campaign;
}

const CampaignTemplateInfo = ({ campaign }: CampaignTemplateInfoProps) => {
  const formatTemplateInfo = () => {
    // Para campanhas first_purchase, mostrar o desconto direto da campanha
    if (campaign.type === 'first_purchase') {
      return `Cupom ${campaign.value}%`;
    }

    // Para campanhas accumulated_spending, verificar se usa cashback customizado
    if (campaign.type === 'accumulated_spending') {
      if (campaign.use_custom_cashback) {
        return `Cashback ${campaign.custom_cashback_percentage}% (personalizado)`;
      } else if (campaign.template_name) {
        return `${campaign.template_name} - ${campaign.template_percentage}%`;
      } else {
        return `Cashback ${campaign.template_percentage || 5}%`;
      }
    }

    // Para outras campanhas, mostrar informações do template ou padrão
    if (campaign.template_name) {
      if (campaign.template_discount_type === 'fixed_percentage') {
        return `${campaign.template_name} - ${campaign.template_percentage}%`;
      } else if (campaign.template_discount_type === 'calculated') {
        return `${campaign.template_name} - ${campaign.template_percentage}% x${campaign.template_multiplier}`;
      }
      return `${campaign.template_name}`;
    }

    return "Configuração padrão";
  };

  const formatMinimumSpent = () => {
    if (campaign.type === "accumulated_spending" && (campaign.minimum_spent_amount || campaign.value)) {
      const amount = campaign.minimum_spent_amount || campaign.value;
      return `Mínimo gasto: R$ ${amount}`;
    }
    return null;
  };

  const isCustomCashback = campaign.use_custom_cashback && campaign.type === 'accumulated_spending';

  return (
    <div className="space-y-1">
      <div className="text-sm font-medium text-gray-900">
        {getCampaignTypeDisplayName(campaign.type)}
      </div>
      
      <div className="flex items-center gap-2">
        <div className={`text-sm px-2 py-1 rounded w-fit ${
          isCustomCashback 
            ? 'text-purple-700 bg-purple-100 border border-purple-200' 
            : 'text-blue-600 bg-blue-50'
        }`}>
          {formatTemplateInfo()}
        </div>
      </div>
      
      {formatMinimumSpent() && (
        <div className="text-xs text-gray-600 bg-gray-50 px-2 py-1 rounded w-fit">
          {formatMinimumSpent()}
        </div>
      )}
    </div>
  );
};

export default CampaignTemplateInfo;
